<template>
  <div class="housewarming-page">
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <div class="qtsc-header">
          <br/>
          <h1 class="blue">QTSC</h1>
          <h1 class="pink">BY</h1>
          <h1 class="white">THE</h1>
          <h1 class="pink">SEA</h1>
          <br/>
        </div>
      </div>
      <div class="sml-col"/>
    </div>
    <img src="../assets/Beach.jpeg" class="housewarming-header" title="Folkestone Beach"/>
    <!-- </div> -->
    <h1>🗓️26/08/23🗓️</h1>
    <h1>🏳️‍⚧️</h1>
    <h1>Come Sing By The Sea</h1>
    <h1>🏳️‍🌈</h1>
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <p>🎶 We would love to host you all in our home for a Song Circle by the sea on <b>Saturday the 26th of August</b>. 🎶</p>
        <h1>⏰</h1>
        <p>Show up anytime from 2pm.</p>
        <h1>🍔</h1>
        <p>We will provide Gluten Free and Veggie/Vegan food. Please bring snacks and food yourself, if you would like.</p>
        <h1>🧑‍🦽</h1>
        <p>Our ground floor and garden are accessible with accessible toilets.</p>
        <h1>🚂 🚘</h1>
        <p>Our closest station is Folkestone Central (10 min walk).</p>
        <p>Our driveway is first come first served, there is free (time limited) parking near us and plenty of parking in town.</p>
        <h1>🏖️</h1>
        <p>We are a short walk from the beach! Feel free to explore the area and come and go as you please.</p>
        <div class="container">
          <h2 class="centered">See you Soooon x</h2>
          <img src="../assets/Mermaid.jpeg" class="housewarming-footer" title="Folkestone Mermaid!"/>
        </div>
      </div>
      <div class="sml-col"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'QTSC',
  }
</script>
<style scoped>
  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1 }
  }

  .qtsc-header {
    background-color: black/*rgb(213, 85, 107)*/;
    border-radius: 70%;

  }
  
  .housewarming-page {
      text-align: center;
      font-size: 16px;
    }
  .housewarming-header {
    height: 100%;
    width: 90%; 
    -webkit-mask-image: linear-gradient(to top, black 75%, transparent 100%);
    mask-image: linear-gradient(to top, black 75%, transparent 100%);
    animation: fadeIn 1.7s;
  }

  .housewarming-footer {
    width: 90%; 
    height: 100%;
  }

  h1 {
    font-size: 3em;
    text-align: center;
    margin-left: 3px;
    margin-right: 3px;
    display: block;
  }

  .blue {
    color: #5BCEFA;
  }

  .pink {
    color: #F5A9B8;
  }

  .white {
    color: #FFF
  }

  h2 {
    font-size: 1.5em;
    text-align: center;
    display: block;
    font-family: cursive;
  }

   .flex-grid {
    display: flex;
  }
  .col {
    flex: 1;
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 40%;
  }

  .flex-grid-thirds .sml-col {
    width: 10%;
    text-align: left;
  }
  .container {
    position: relative;
    text-align: center;
    color: white;
  }
  .centered {
    position: absolute;
    left: 20%;
    top: 20%;
  }
</style>
